<template>
  <button :dataset-id="button.id" :style="coordinates" :class="activeButton" :data-xcoord="button.imageXCoord"
    :data-ycoord="button.imageYCoord" @click="
      loadSidePanelData(button);
    zoomToPin($event);
    " :aria-label="name(button.name)" aria-controls="side-nav-wide">
    <div class="btn-svg"></div>
    <div class="svg-container">
      <svg version="1.1" class="mapPinSvg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px" y="0px" viewBox="0 0 40 40" style="enable-background: new 0 0 40 40; height: 40px" xml:space="preserve">
        <path class="st0" d="M20,9C13.9,9,9,13.9,9,20c0,6.1,4.9,11,11,11c6.1,0,11-4.9,11-11C31,13.9,26.1,9,20,9z M20,28.3
    c-4.6,0-8.3-3.7-8.3-8.3s3.7-8.3,8.3-8.3c4.6,0,8.3,3.7,8.3,8.3S24.6,28.3,20,28.3z" />
        <path class="outer" :class="activeComponent"
          d="M20,4.5c-8.6,0-15.5,7-15.5,15.5c0,8.6,7,15.5,15.5,15.5c8.6,0,15.5-7,15.5-15.5
    C35.5,11.4,28.6,4.5,20,4.5z M20,31c-6.1,0-11-4.9-11-11c0-6.1,4.9-11,11-11c6.1,0,11,4.9,11,11C31,26.1,26.1,31,20,31z" />
        <path class="st1" :class="activeComponent"
          d="M20,11.7c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3c4.6,0,8.3-3.7,8.3-8.3S24.6,11.7,20,11.7z" />
      </svg>
    </div>
  </button>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { dragAndZoom } from "src/mixins/dragAndZoom.js";

import { createUrlString } from "src/store/helpers.js";

export default {
  name: "MapButton",
  props: ["button"],
  mixins: [dragAndZoom],
  data() {
    return {
      coordinates: "",
    };
  },
  computed: {
    ...mapGetters([
      "activeComponent",
      "SideNavigationWideOpen",
      "activeMapButton",
    ]),
    activeButton: function () {
      if (this.activeMapButton === this.button.id) {
        return "activeBtn";
      }
    },
  },
  methods: {
    ...mapActions(["setActiveMapButton", "activateSidePanelData"]),
    loadSidePanelData(button) {
      // Prompt vue-router to load new route, based on name and given parameters
      if (this.activeMapButton != button.id) {
        this.setActiveMapButton(button.id);
        this.$router.push({
          name: "componentpage_subcomponent",
          params: {
            componentName: this.$router.currentRoute.params.componentName,
            view: this.$router.currentRoute.params.view,
            dataType: this.$router.currentRoute.params.dataType,
            subComponent: createUrlString(button.name.split(":").pop()),
          },
        });
        document.querySelector("#close-button").focus();
      } else {
        this.zoom(true, 1);
        this.setActiveMapButton(null);
        this.$router.push({
          name: "componentpage_datatype",
          params: {
            componentName: this.$router.currentRoute.params.componentName,
            view: this.$router.currentRoute.params.view,
            dataType: this.$router.currentRoute.params.dataType,
          },
        });
      }
    },
    /**
     * @description zoom and drag to selected map pin
     * @param {} event
     */

    name: function (name) {
      return name.split(":").pop();
    },
  },
  created() {
    this.coordinates = `top: ${this.button.imageYCoord}%; left:${this.button.imageXCoord}%`;
  },
};
</script>
<style lang="scss" scoped>
svg {
  pointer-events: none;
}

button:hover {
  .mapPinSvg {
    .R-luokka {
      fill: #ea6708;
    }

    .L-luokka {
      fill: #ea6708;
    }

    .S-luokka {
      fill: #ea6708;
    }
  }
}

.svg-container {
  position: relative;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    .mapPinSvg {
      .R-luokka {
        fill: #ea6708;
      }

      .L-luokka {
        fill: #ea6708;
      }

      .S-luokka {
        fill: #ea6708;
      }
    }
  }
}

.activeBtn {
  .R-luokka {
    fill: #ea6708 !important;
  }

  .L-luokka {
    fill: #ea6708 !important;
  }

  .S-luokka {
    fill: #ea6708 !important;
  }
}

.outer {
  stroke: #fff;
  stroke-width: 1px;
  stroke-linejoin: round;
}

.R-luokka {
  fill: #00a9e0;
  border: rgb(17, 5, 37);
  transition: fill 0.2s;
}

.L-luokka {
  fill: #00a9e0;
  border: rgb(17, 5, 37);
}

.S-luokka {
  fill: #00a9e0;
  border: rgb(17, 5, 37);
}

.st0 {
  fill: #ffffff;
}
</style>